import API from '../../utils/Api'
import i18n from '@/plugins/i18n'

const api = new API('orders')
const apiInstances = new API('instances')


const state = {
  list: [],
  loading: false,
  model: {
    firstname: "",
    lastname: "",
    login: "",
    role: "",
    password: "",
    lang: ""
  }
}

const getters = {

  loading (state) {
    return state.loading
  },

  list (state) {
    return state.list
  },

  model (state) {
    return state.model
  },

  headers () {
    return [
      {
        text: i18n.t('tokens.date'),
        align: 'center',
        value: 'createdAtFormated'
      },
      {
        text: i18n.t('tokens.number'),
        align: 'center',
        value: 'tokens'
      },
      {
        text: i18n.t('tokens.cost'),
        align: 'center',
        value: 'cost'
      },
      {
        text: i18n.t('tokens.bill'),
        align: 'center',
        value: 'billLogo',
        logo: true,
        logoClick: true
      },
      {
        text: i18n.t('general.actions'),
        align: 'center',
        sortable: false
      }
    ]
  },

  status () {
    return [
      {
        name: i18n.t('roles.trainner'),
        number: 1
      },
      {
        name: i18n.t('roles.admin'),
        number: 2
      },
      {
        name: i18n.t('roles.superAdmin'),
        number: 3
      }
    ]
  }

}

const actions = {

  async getTokenNumber({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await apiInstances.get(id + '/tokens')
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.users.getOneError') + error.message }, { root: true })
    }
  },

  async getOne({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await api.get(id)
      commit('SET_current', res.data)
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.users.getOneError') + error.message }, { root: true })
    }
  },

  async getAll({ commit }) {
    try {
      commit('SET_loading', true)
      let res = await api.getAll()
      commit('SET_list', res.data)
      commit('SET_loading', false)
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.users.getAllError') + error.message }, { root: true })
    }
  },

  async add({ commit }, data) {
    try {
      commit('SET_loading', true)
      let res = await api.post(data, '')
      commit('ADD_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.users.add') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.users.addError') + error.message }, { root: true })
      return false
    }
  },

  async update({ commit, dispatch }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "")
      commit('UPDATE_list', res.data)
      await dispatch('interfaceSettings/changeLang', res.data.lang, { root: true })
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.users.update') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.users.updateError') + error.message }, { root: true })
      return false
    }
  },

  async delete({ commit }, params) {
    try {
      commit('SET_loading', true)
      await api.deleteMany(params)
      commit('DELETE_list', params)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.users.delete') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.users.deleteError') + error.message }, { root: true })
      return false
    }
  }

}

const mutations = {

  DELETE_list(state, toDelete) {
    for (let i = 0; i < toDelete.length; i++) {
      for (let index = 0; index < state.list.length; index++) {
        if (state.list[index]._id === toDelete[i]) {
          state.list.splice(index, 1)
          break
        }
      }
    }
  },

  UPDATE_list(state, val) {
    for (let index = 0; index < state.list.length; index++) {
      if (state.list[index]._id === val._id) {
        state.list.splice(index, 1, val)
        break
      }
    }
  },

  ADD_list(state, val) {
    state.list.push(val)
  },

  SET_list(state, val) {
    state.list = val
  },

  SET_loading(state, val) {
    state.loading = val
  }
  
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}